import "../../styles/style"
import "../../tabs/style"
import "../index.scss"
